import { render } from "./SchoolInfo.vue?vue&type=template&id=5491ad39&ts=true"
import script from "./SchoolInfo.vue?vue&type=script&lang=ts"
export * from "./SchoolInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__